import api from './api';

export const getSettings    = ()     => api.get('/api/settings');
export const updateSettings = (data) => api.put('/api/settings', data);

// Ledger opening balances (dated seed) — Primary Admin only, audit-logged.
export const updateOpeningBalances = (data) => api.put('/api/settings/opening-balances', data);
